function l(l,n,r=!0){if(!n||"string"!=typeof n)return null;if(l&&l.vars&&r){const r=`vars.${n}`.split(".").reduce(((l,n)=>l&&l[n]?l[n]:null),l);if(null!=r)return r}return n.split(".").reduce(((l,n)=>l&&null!=l[n]?l[n]:null),l)}export{l as getPath};
//# sourceMappingURL=style.js.map
